import { BarChart, Card } from "@bfc-software/pallet";

import {
  averagePerHour,
  hourLabel,
  type HourlyPieces,
} from "../-data/dashboard-model";
import type { DashboardT } from "./dashboard-t";
import styles from "./dashboard.module.css";

/** Pieces picked per hour, against the shift's average. */
export function PiecesPerHour({
  hourly,
  t,
}: {
  hourly: ReadonlyArray<HourlyPieces>;
  t: DashboardT;
}) {
  const average = averagePerHour(hourly);

  return (
    <Card
      variant="panel"
      layout="body-only"
      data-test-role="dashboard-pph"
      body={
        <>
          <div className={styles.panelHead}>
            <span className={styles.panelTitle}>
              {t("dashboard.pph.title")}
            </span>
            <span className={styles.panelHint}>
              {t("dashboard.pph.average", { value: average })}
            </span>
          </div>
          <BarChart
            aria-label={t("dashboard.pph.ariaLabel")}
            bars={hourly.map((h) => ({
              key: String(h.hour),
              label: h.partial
                ? t("dashboard.pph.now", { hour: hourLabel(h.hour) })
                : hourLabel(h.hour),
              value: h.pieces,
              partial: h.partial,
              current: h.partial,
            }))}
            reference={{
              value: average,
              label: t("dashboard.pph.average", { value: average }),
            }}
          />
        </>
      }
    />
  );
}
